import * as Cesium from 'cesium';
import { Col } from "react-bootstrap";
import styled from "styled-components";
import StacInterface from "utils/StacInterface";
import { Visibility } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { TILESAPI_BASE_URL } from "utils/base_urls";
import { useDispatch, useSelector } from "react-redux";
import useViewerStore from '../../store-zustand/viewer';
import { getLayerCollectionDetail } from '@/utils/helpers';
import { Box, ImageList, ImageListItem, ImageListItemBar, IconButton } from "@mui/material";

const Row = styled(Box)`
  background: ${(props) => (props.index % 2 === 0 ? "#232323" : "#2f2f2f")};
  overflow: auto;
  height: fit-content;
  max-height: 610px;
`;

const TabContent = (props) => {
  const dispatch = useDispatch();
  const { tabInfo, tabValue } = props;
  const { viewer } = useViewerStore();
  const [assetImages, setAssetImages] = useState({});
  const [selectedImage, setSelectedImage] = useState();
  const selectedLayer = useSelector(state => state.asset.selectedMission);

  useEffect(() => {
    if (!tabInfo || Object.keys(tabInfo).length === 0) return;

    let images = {};
    let loading_images = Object.keys(tabInfo).map((uuid, _) => {
      return StacInterface.instance.getThumbnail(uuid).then((response) => {
        images[uuid] = URL.createObjectURL(response.data);
      }).catch(() => images[uuid] = null);
    });

    Promise.all(loading_images).then(() => {
      setAssetImages(images);
    });
  }, [tabInfo]);

  const turnOffLayers = () => {
    for (let layer in window.HDImagery) {
      for (let styleOrUUID in window.HDImagery[layer]) {
        if (['rgb', 'nir', 'greyscale', 'hillshade', 'schwarzwald'].includes(styleOrUUID)) {
          window.HDImagery[layer][styleOrUUID].show = false;
        } else {
          for (let style in window.HDImagery[layer][styleOrUUID]) {
            window.HDImagery[layer][styleOrUUID][style].show = false;
          }
        }
      }
    }
  }

  const setMapOrientation = () => {
    let collection_detail = getLayerCollectionDetail(tabValue);
    let cardinal_direction = collection_detail[1].cardinal_direction;
    let heading = (cardinal_direction === 0 || cardinal_direction === 1) ? 0 : cardinal_direction === 2 ? 90 : cardinal_direction === 3 ? 180 : 270;

    viewer.camera.flyTo({
      destination: viewer.camera.position.clone(),
      orientation: {
        heading: Cesium.Math.toRadians(heading),
        pitch: viewer.camera.pitch,
        roll: viewer.camera.roll,
      },
    });
  };

  const addObliqueLayerToHDImagery = (layer, uuid, style) => {
    window.HDImagery[layer][uuid][style] = viewer.imageryLayers.addImageryProvider(
      new Cesium.UrlTemplateImageryProvider({
        url: new Cesium.Resource({
          url: `${TILESAPI_BASE_URL}/v2/OSG/TMS/oblique/${layer}/${uuid}/{z}/{x}/{y}?image_type=${style}&tilesize=512&minLevel=10`,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem("tiles_api_auth0_token")}`
          },
        }),
        tileWidth: 512,
        tileHeight: 512
      }), 1);
    window.HDImagery[layer][uuid][style].show = true;
  }

  const handleTileClick = (event) => {
    if (event.target.ariaLabel === null || event.target.ariaLabel === "") return;

    setSelectedImage(event.target.ariaLabel);
    let _, mission = selectedLayer.split(':')[1];

    turnOffLayers();
    ['rgb'].map((style) => {
      let layer = `${tabValue}:${mission}`;
      let uuid = event.target.ariaLabel;
      if (layer in window.HDImagery && uuid in window.HDImagery[layer] && style in window.HDImagery[layer][uuid]) {
        window.HDImagery[layer][uuid][style].show = true;
      } else {
        if (!(layer in window.HDImagery)) window.HDImagery[layer] = {};
        if (!(uuid in window.HDImagery[layer])) window.HDImagery[layer][uuid] = {};
          
        addObliqueLayerToHDImagery(layer, uuid, style);
      }
      dispatch({ type: 'SET_SELECTED_OBLIQUE', selectedOblique: `${tabValue}:${uuid}` })
    });
    setMapOrientation();
  }

  return (
    <>
      {assetImages != {} &&
        <Row display="flex" justifyContent="space-between" width="100%">
          <Col md={12} lg={12}>
            <ImageList sx={{ width: 300, height: '95%' }} cols={1}>
              {Object.keys(tabInfo).map((item, _) => (
                <ImageListItem key={item} cols={1} rows={3} style={{ 'align-items': 'center' }}>
                  <img src={assetImages[item]} style={{ 'max-height': '200px', 'max-width': '200px' }} />
                  <ImageListItemBar key={item}
                    title={new Date(tabInfo[item]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' })}
                    style={selectedImage === item ? { background: "#287bf254" } : {}}
                    actionIcon={
                      <IconButton onMouseDown={handleTileClick} aria-label={item} sx={{ color: 'rgba(255, 255, 255, 0.54)' }} title={`Show tile`} >
                        <Visibility aria-label={item} />
                      </IconButton>
                    } />
                </ImageListItem>
              ))}
            </ImageList>
          </Col>
        </Row>
      }
    </>
  );
};

export default TabContent;